import { ARBITRUM, AVALANCHE, AVALANCHE_FUJI } from "./chains";

/*
  A temporary solution before positions sorting logic is updated
  to not depend on marketInfo sorting.

  When adding new markets, add them to the end of the list
  or update arrays based on marketInfo sorting in runtime
*/
export const SORTED_MARKETS = {
  [ARBITRUM]: [
    "0x47c031236e19d024b42f8AE6780E44A573170703",
    "0x7C11F78Ce78768518D743E81Fdfa2F860C6b9A77",
    "0xd62068697bCc92AF253225676D618B0C9f17C663",
    "0x70d95587d40A2caf56bd97485aB3Eec10Bee6336",
    "0x450bb6774Dd8a756274E0ab4107953259d2ac541",
    "0x0Cf1fb4d1FF67A3D8Ca92c9d6643F8F9be8e03E5",
    "0x09400D9DB990D5ed3f35D7be61DfAEB900Af03C9",
    "0xf22CFFA7B4174554FF9dBf7B5A8c01FaaDceA722",
    "0x7f1fa204bb700853D36994DA19F830b6Ad18455C",
    "0xe2730Ffe2136aA549327EBce93D58160df7821CB",
    "0x0CCB4fAa6f1F1B30911619f1184082aB4E25813c",
    "0x6Ecf2133E2C9751cAAdCb6958b9654baE198a797",
    "0x55391D178Ce46e7AC8eaAEa50A72D1A5a8A622Da",
    "0xbD48149673724f9cAeE647bb4e9D9dDaF896Efeb",
    "0x4c505e0062459cf8F60FfF13279c92ea15aE6e2D",
    "0xa8A455Ed94b315460CfF7d96966d91330f6A3bA0",
    "0x63Dc80EE90F26363B3FCD609007CC9e14c8991BE",
    "0x0c11Ed89889Fd03394E8d9d685cC5b85be569C99",
    "0x6853EA96FF216fAb11D2d930CE3C508556A4bdc4",
    "0xC25cEf6061Cf5dE5eb761b50E4743c1F5D7E5407",
    "0xD9377d9B9a2327C7778867203deeA73AB8a68b6B",
    "0xD60f1BA6a76979eFfE706BF090372Ebc0A5bF169",
    "0x7BbBf946883a5701350007320F525c5379B8178A",
    "0x04DecfB37e46075189324817df80a32D22b9eD8D",
    "0x75F190E0Be6E8B933A01423EFE398c6C721A5CfF",
    "0x1CbBa6346F110c8A5ea739ef2d1eb182990e4EB2",
    "0x77B2eC357b56c7d05a87971dB0188DBb0C7836a5",
    "0x4D3Eb91efd36C2b74181F34B111bc1E91a0d0cb4",
    "0xc7Abb2C5f3BF3CEB389dF0Eecd6120D451170B50",
    "0xD8471b9Ea126272E6d32B5e4782Ed76DB7E554a4",
    "0x4d9bA415649c4B3c703562770C8ff3033478Cea1",
    "0xFec8f404FBCa3b11aFD3b3f0c57507C2a06dE636",
    "0xdc4e96A251Ff43Eeac710462CD8A9D18Dc802F18",
    "0x9F159014CC218e942E9E9481742fE5BFa9ac5A2C",
    "0xdE967676db7b1ccdBA2bD94B01B5b19DE4b563e4",
    "0x2b477989A149B17073D9C9C82eC9cB03591e20c6",
    "0x0Bb2a83F995E1E1eae9D7fDCE68Ab1ac55b2cc85",
    "0xBcb8FE13d02b023e8f94f6881Cc0192fd918A5C0",
    "0xD9535bB5f58A1a75032416F2dFe7880C30575a41",
    "0x2d340912Aa47e33c90Efb078e69E70EFe2B34b9B",
    "0xcaCb964144f9056A8f99447a303E60b4873Ca9B4",
    "0x262B5203f0fe00D9fe86ffecE01D0f54fC116180",
    "0x15c6eBD4175ffF9EE3c2615c556fCf62D2d9499c",
    "0x248C35760068cE009a13076D573ed3497A47bCD4",
    "0xe55e1A29985488A2c8846a91E925c2B7C6564db1",
    "0xBeB1f4EBC9af627Ca1E5a75981CE1AE97eFeDA22",
    "0x784292E87715d93afD7cb8C941BacaFAAA9A5102",
    "0xD0a1AFDDE31Eb51e8b53bdCE989EB8C2404828a4",
    "0x876Ff160d63809674e03f82DC4D3C3Ae8B0acF28",
    "0x89EB78679921499632fF16B1be3ee48295cfCD91",
    "0xfD46a5702D4d97cE0164375744c65F0c31A3901b",
    "0x16466a03449CB9218EB6A980Aa4a44aaCEd27C25",
    "0x62feB8Ec060A7dE5b32BbbF4AC70050f8a043C17",
    "0xe902D1526c834D5001575b2d0Ef901dfD0aa097A",
    "0x7B2D09fca2395713dcc2F67323e4876F27b9ecB2",
    "0x7DE8E1A1fbA845A330A6bD91118AfDA09610fB02",
    "0x93385F7C646A3048051914BDFaC25F4d620aeDF1",
    "0x71237F8C3d1484495A136022E16840b70fF84a69",
    "0xdAB21c4d1F569486334C93685Da2b3F9b0A078e8",
    "0xD4b737892baB8446Ea1e8Bb901db092fb1EC1791",
    "0x4fDd333FF9cA409df583f306B6F5a7fFdE790739",
    "0xB489711B1cB86afDA48924730084e23310EB4883",
    "0xB62369752D8Ad08392572db6d0cc872127888beD",
    "0x12fD1A4BdB96219E637180Ff5293409502b2951D",
    "0x467C4A46287F6C4918dDF780D4fd7b46419c2291",
    "0x872b5D567a2469Ed92D252eaCB0EB3BB0769e05b",
    "0x66A69c8eb98A7efE22A22611d1967dfec786a708",
    "0x970e578fF01589Bb470CE38a2f1753152A009366",
    "0x3680D7bFE9260D3c5DE81AEB2194c119a59A99D1",
    "0x6CB901Cc64c024C3Fe4404c940FF9a3Acc229D2C",
    "0x8ea4Fb801493DaD8724F90Fb2e279534fa591366",
    "0xFaC5fF56c269432706d47DC82Ab082E9AE7D989E",
    "0x2aE5c5Cd4843cf588AA8D1289894318130acc823",
    "0x71B7fF592a974e2B501D8A7a11f5c42DcD365244",
    "0xE61e608Ba010fF48A7dcE8eDd8B906744263d33E",
    "0x0418643F94Ef14917f1345cE5C460C37dE463ef7",
    "0x5707673D95a8fD317e2745C4217aCD64ca021B68",
    "0x9e79146b3A022Af44E0708c6794F03Ef798381A5",
    "0x9C2433dFD71096C435Be9465220BB2B189375eA7",
    "0xB686BcB112660343E6d15BDb65297e110C8311c4",
    "0xe2fEDb9e6139a182B98e7C2688ccFa3e9A53c665",
    "0xb56E5E2eB50cf5383342914b0C85Fe62DbD861C8",
    "0x45aD16Aaa28fb66Ef74d5ca0Ab9751F2817c81a4",
  ],
  [AVALANCHE]: [
    "0x913C1F46b48b3eD35E7dc3Cf754d4ae8499F31CF",
    "0x08b25A2a89036d298D6dB8A74ace9d1ce6Db15E5",
    "0xFb02132333A79C8B5Bd0b64E3AbccA5f7fAf2937",
    "0x3ce7BCDB37Bf587d1C17B930Fa0A7000A0648D12",
    "0xB7e69749E3d2EDd90ea59A4932EFEa2D41E245d7",
    "0x2A3Cf4ad7db715DF994393e4482D6f1e58a1b533",
    "0xd2eFd1eA687CD78c41ac262B3Bc9B53889ff1F70",
    "0x8970B527E84aA17a33d38b65e9a5Ab5817FC0027",
    "0xD1cf931fa12783c1dd5AbB77a0706c27CF352f25",
    "0xA74586743249243D3b77335E15FE768bA8E1Ec5A",
    "0xfB626c4e3E153947A6A94041814c25E449064dAD",
    "0xe19da27Bf9733c429445E289B662bECDCa6ce10b",
  ],
  [AVALANCHE_FUJI]: [
    "0xbf338a6C595f06B7Cfff2FA8c958d49201466374",
    "0xDdF708B284C5C26BE67Adf9C51DFa935b5035bF8",
    "0xe28323955C05B75E25B56C1c996C1354Eb5Aa13D",
    "0x6d72D2787107c32a48bbA4687Eb8F9C19FE5e29C",
    "0x79E6e0E454dE82fA98c02dB012a2A69103630B07",
    "0x4b6ccF6E429f038087A26b13DD6ab4304F7E5DF1",
    "0xd783EB54407d6d3A4D5c94b634eC9BAE3F574098",
    "0x3b649015Fe0a4d15617e57aA11c0FbbfA03A9e11",
    "0x017de90B0fa830C592805C6148c089191716f04c",
    "0xEDF9Be35bE84cD1e39Bda59Bd7ae8A704C12e06f",
    "0xAC2c6C1b0cd1CabF78B4e8ad58aA9d43375318Cb",
    "0xeDf53322e288F597436f5d5849771662AEe16A1C",
    "0xE446E8f7074c0A97bb7cd448fA2CC3346045F514",
    "0xD996ff47A1F763E1e55415BC4437c59292D1F415",
  ],
};
